import { useMemo } from 'react';
import { StyleSheet } from 'react-native';
import { useColors } from '../../hooks/useColors';
import { useScale } from '../../hooks/useScale';
import theme from '../../common/theme';

const TooltipStyles = () => {
  const { colors } = useColors();
  const { scale } = useScale();

  return useMemo(
    () =>
      StyleSheet.create({
        wrapper: {
          position: 'absolute',
          bottom: '80%',
          alignItems: 'center',
          zIndex: 1,
        },
        container: {
          backgroundColor: colors.elevation1,
          padding: scale(6),
          borderRadius: theme.radius.s,
          alignItems: 'center',
          justifyContent: 'center',
        },
        text: {
          color: colors.text,
          fontSize: scale(12),
          textAlign: 'center',
        },
        arrow: {
          width: 0,
          height: 0,
          borderLeftWidth: scale(6),
          borderRightWidth: scale(6),
          borderTopWidth: scale(6),
          borderLeftColor: colors.transparent,
          borderRightColor: colors.transparent,
          borderTopColor: colors.elevation1,
        },
      }),
    [colors, scale],
  );
};

export default TooltipStyles;
